import axios from 'axios';

// 1. Define Constants and Helpers FIRST
const BASE = 'https://api.atrmart.in/martapi';

export const getToken  = () => localStorage.getItem('seller_token');
export const setToken  = (t) => localStorage.setItem('seller_token', t);
export const clearAuth = () => {
  localStorage.removeItem('seller_token');
  localStorage.removeItem('seller_user');
};

// 2. Core Request Interceptor
const SellerApi = async (endpoint, options = {}) => {
  const token = getToken();
  const headers = {
    'Accept': 'application/json',
    ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(`${BASE}${endpoint}`, { ...options, headers });

  if (res.status === 401) { 
    clearAuth(); 
    window.location.href = '/martseller'; 
    return; 
  }

  const json = await res.json().catch(() => ({ status: false, message: 'Server error' }));

  if (!res.ok) throw new Error(json.message || `Error ${res.status}`);
  return json;
};

// 3. API Sub-Modules
export const authAPI = {
  sendOtp:     (mobile) => SellerApi('/auth/send-otp', { method: 'POST', body: JSON.stringify({ mobile, role: 'seller' }) }),
  verifyOtp:   (mobile, otp) => SellerApi('/auth/verify-otp', { method: 'POST', body: JSON.stringify({ mobile, otp }) }),
  register:    (data) => SellerApi('/auth/register-seller', { method: 'POST', body: JSON.stringify(data) }),
};

export const dashAPI = {
  getStats:         () => SellerApi('/seller/dashboard/stats'),
  getRecentOrders:  () => SellerApi('/seller/dashboard/orders/recent'),
};

export const productAPI = {
  list:   () => SellerApi('/seller/products'),
  create: (data) => SellerApi('/seller/products', { method: 'POST', body: JSON.stringify(data) }),
  update: (id, data) => SellerApi(`/seller/products/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id) => SellerApi(`/seller/products/${id}`, { method: 'DELETE' }),
};

export const orderAPI = {
  list:         () => SellerApi('/seller/orders'),
  updateStatus: (id, status) => SellerApi(`/seller/orders/${id}/status`, { method: 'PUT', body: JSON.stringify({ status }) }),
};

export const returnAPI = {
  list:   () => SellerApi('/seller/returns'),
  action: (id, action) => SellerApi(`/seller/returns/${id}/action`, { method: 'POST', body: JSON.stringify({ action }) }),
};

export const walletAPI = {
  balance:      () => SellerApi('/seller/wallet/balance'),
  transactions: () => SellerApi('/seller/wallet/transactions'),
  withdraw:     (amount) => SellerApi('/seller/wallet/withdraw', { method: 'POST', body: JSON.stringify({ amount }) }),
  bankDetails:  () => SellerApi('/seller/wallet/bank'),
  saveBank:     (data) => SellerApi('/seller/wallet/bank', { method: 'POST', body: JSON.stringify(data) }),
};

export const dealAPI = {
  list:   () => SellerApi('/seller/deals'),
  create: (data) => SellerApi('/seller/deals', { method: 'POST', body: JSON.stringify(data) }),
  delete: (id)   => SellerApi(`/seller/deals/${id}`, { method: 'DELETE' }),
};

export const profileAPI = {
  get:    () => SellerApi('/seller/profile'),
  update: (data) => SellerApi('/seller/profile', { method: 'PUT', body: JSON.stringify(data) }),
  updateAddress: (data) => SellerApi('/seller/profile/address', { method: 'PUT', body: JSON.stringify(data) }),
  agreePolicies:() => SellerApi('/seller/profile/agree-policies', { method: 'POST' }),
};

export const notifAPI = {
  list:        () => SellerApi('/seller/notifications'),
  markAllRead: () => SellerApi('/seller/notifications/read-all'),
};